import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";

import SensitiveContentConfirmModal from "../../curriculum_manager/components/modals/sensitive_content_confirm_modal";

export default class AddSearchResultButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.itemAdded = this.itemAdded.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
    this.state = { adding: false, done: false, showConfirmModal: false };
  }

  itemAdded(e) {
    if (e.detail.added) {
      this.setState({ ...this.state, done: true });
      setTimeout(() => {
        this.setState({ ...this.state, done: false, adding: false });
      }, 3000);
    } else {
      this.setState({ ...this.state, adding: e.detail.adding });
    }
  }

  onClick(e) {
    e.preventDefault();

    this.props.isRequireTeacherAcknowledgment
      ? this.openConfirmationModal()
      : this.handleClick();
  }

  openConfirmationModal() {
    this.setState({ showConfirmModal: true });
  }

  closeConfirmationModal() {
    this.setState({ showConfirmModal: false });
  }

  handleClick() {
    if (this.state.adding) return;

    document.dispatchEvent(
      new CustomEvent("search-card-add", {
        detail: {
          collectionItemType: this.props.itemType,
          id: this.props.id,
          classType: this.props.type,
          searchCardAdd: true,
        },
      })
    );

    document.removeEventListener(`adding-${this.props.id}`, this.itemAdded);
    document.addEventListener(`adding-${this.props.id}`, this.itemAdded);
  }

  onConfirm() {
    this.setState({ showConfirmModal: false });
    this.handleClick();
  }

  classNames() {
    const { adding, done } = this.state;
    let classes = "react-mounted resource-card-add-button clickable";
    if (adding) classes += " adding";
    if (done) classes += " added";

    return classes;
  }

  render() {
    return (
      <>
        <div className={this.classNames()} onClick={this.onClick}>
          <span className="plus">+</span>
          <span className="lp-icon-check fa-solid fa-check"></span>
        </div>
        {this.state.showConfirmModal && (
          <SensitiveContentConfirmModal
            onSubmit={this.onConfirm}
            onClose={this.closeConfirmationModal}
          />
        )}
      </>
    );
  }
}

AddSearchResultButton.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  isRequireTeacherAcknowledgment: PropTypes.bool,
};

export function bindAddToCBButtons() {
  const addToBuilderButtons = document.getElementsByClassName("add-to-builder");
  const alreadyRenderedClass = "rendered";
  for (let i = 0; i < addToBuilderButtons.length; i += 1) {
    const item = addToBuilderButtons[i];
    if (!item.classList.contains(alreadyRenderedClass)) {
      item.classList.add(alreadyRenderedClass);
      ReactDOM.createRoot(item).render(
        React.createElement(AddSearchResultButton, {
          ...item.dataset,
          isRequireTeacherAcknowledgment:
            item.dataset.isRequireTeacherAcknowledgment === "true",
        })
      );
    }
  }
}
